import React, { FC, useCallback } from 'react'
import { TableFormList } from 'modules/Labels/components'

import { IUnit } from 'shared/interfaces'
import { UnitFormProps } from './UnitForm.props'

const UnitForm: FC<UnitFormProps> = ({ onCreateUnit, onUpdateUnit, units, setShowAlert }) => {
  const onChangeUnit = useCallback(
    (value) => {
      if (value.id) {
        return onUpdateUnit({
          id: value.id,
          label_id: value.label_id,
          name: value.name
        })
      } else {
        return onCreateUnit({ name: value.name } as IUnit)
      }
    },
    [onUpdateUnit, onCreateUnit]
  )

  return (
    <form className="label-form">
      <h4 className="label-form__title">Units</h4>
      <TableFormList
        entity="Unit"
        fieldName="name"
        defaultList={units}
        onHandleChangeForm={onChangeUnit}
        setShowAlert={setShowAlert}
      />
    </form>
  )
}

export default UnitForm
